import { TslDebug } from '@/components/TslDebug';
import TslDebugArea from '@/components/TslDebugArea';
import WebGpuCanvas from '@/components/WebGpuCanvas';
import { OrbitControls, PerspectiveCamera } from '@react-three/drei';
import * as React from 'react';
import { positionLocal, length, Fn, sin, time, rotateUV, vec2, atan, cos, vec3 } from 'three/tsl';

export type Props = {};

function App05(props: Props) {
  const {} = props;
  const main = React.useMemo(() => {
    const ret = Fn(() => {
      const p = positionLocal.toVar();
      p.assign(rotateUV(p.xy, time, vec2()));
      p.assign(length(p.mul(5)).sub(atan(p.zy, p.zx)).mul(5));
      p.sinAssign();
      p.mulAssign(5);
      p.assign(vec3(p.x.add(sin(time).mul(5)), p.y.add(cos(time).mul(5)), 0));
      return p;
    });
    return ret();
  }, []);
  return (
    <TslDebugArea>
      {(el) => (
        <WebGpuCanvas>
          <PerspectiveCamera
            makeDefault
            fov={53}
            aspect={el.clientWidth / el.clientHeight}
            near={0.1}
            far={10}
            position={[0, 0, 1]}
          />
          <mesh name="node-mesh">
            {/* <boxGeometry args={[1, 1, 1]} /> */}
            <planeGeometry args={[2, 1]} />
            <nodeMaterial fragmentNode={main} />
            <TslDebug meshName={'node-mesh'} />
          </mesh>
          <axesHelper />
          <OrbitControls />
        </WebGpuCanvas>
      )}
    </TslDebugArea>
  );
}

export default React.memo(App05);
